import { bool, mixed, object, string } from "yup";
import { dayjs } from "@thalamos/common";
import { S132Outcome, S132WithdrawalReason } from "../types/s132/S132.js";
import { s132SectionsOwingDuty } from "../util/s132.js";
export const S132_REASON_MAX = 1000;
export const S132_NOTES_MAX = 2000;
export const S132_NAME_MAX = 150;
/** The one definition of a valid attempt; validate against it wherever one is accepted. */
export const recordS132AttemptSchema = object({
    section: mixed()
        .oneOf(s132SectionsOwingDuty, "Choose the section you explained")
        .required("Choose the section you explained"),
    occurredAt: string()
        .required("Enter when the patient was read their rights")
        .test("valid", "Enter a valid date and time", (value) => dayjs(value).isValid())
        .test("notInFuture", "This can't be in the future", 
    // A minute's grace for clock skew between the recording device and the server.
    (value) => !dayjs(value).isAfter(dayjs().add(1, "minute"))),
    outcome: mixed()
        .oneOf(Object.values(S132Outcome), "Say whether the patient has the capacity to understand the information")
        .required("Say whether the patient has the capacity to understand the information"),
    reason: string()
        .trim()
        .max(S132_REASON_MAX)
        .when("outcome", {
        is: (outcome) => outcome !== S132Outcome.Understood,
        then: (schema) => schema.required("Provide more information"),
        otherwise: (schema) => schema.optional(),
    }),
    writtenInformationGiven: bool().required("Say whether you provided written information"),
    deliveredByName: string().trim().max(S132_NAME_MAX).optional(),
    notes: string().trim().max(S132_NOTES_MAX).optional(),
});
export const correctS132AttemptSchema = recordS132AttemptSchema.shape({
    correctionReason: string()
        .trim()
        .max(S132_REASON_MAX)
        .required("Give a reason for amendment"),
});
export const withdrawS132AttemptSchema = object({
    reason: mixed()
        .oneOf(Object.values(S132WithdrawalReason), "Say why this entry is being deleted")
        .required("Say why this entry is being deleted"),
    detail: string()
        .trim()
        .max(S132_REASON_MAX)
        .required("Explain why this entry is being deleted"),
});
//# sourceMappingURL=s132.js.map